import axios from '@/plugins/axios';

export default {
    namespaced: true,

    state: {
        entity: {}
    },

    mutations: {
        SET_ENTITY(state, payload) {
            state.entity = { ...payload };
        },
        CLEAR_ENTITY(state) {
            state.entity = {};
        },
    },

    actions: {
        async get({ commit }, { entity_id }) {
            const { data } = await axios.get(`/admin/sites/${ entity_id }/style`);
            commit('SET_ENTITY', data);
            return data;
        },
        async save({ commit, state }, { entity_id }) {
            let response = {};
            if(state.entity.id) {
                response = await axios.put(`/admin/sites/${ entity_id }/style/${ state.entity.id }`, state.entity);
            } else {
                response = await axios.post(`/admin/sites/${ entity_id }/style`, state.entity);
            }
            return response.data;
        },
        async delete({ commit }, { entity_id, id }) {
            await axios.delete(`/admin/sites/${ entity_id }/style/${ id }`);
        },
    },

    getters: {}
}
